// import Vue from 'vue'
import { UserCenterService, bUserService, medicalUserService, middlewareService } from '@/utils/axios'
import { timeFix, getUrlParams } from '@/utils/util'
import { notification } from 'ant-design-vue'
// import { A_ACCESS_TOKEN, A_TENANT_ID, A_DOTNET_ACCESS_TOKEN } from '@/store/mutation-types'
export const api = {
  ALogin: '/api/TokenAuth/Authenticate', // A平台登录
  BLogin: '/api/TokenAuth/Authenticate', // B平台登录
  getATenantList: '/api/services/app/Tenant/GetAll', // 获取授权平台列表
  SendAliSmsAsync: '/api/services/app/Account/SendAliSmsAsync/v2', // 发送手机验证码
  GetCaptchaAccountByPhone: '/api/services/app/Account/GetCaptchaAccountByPhone', // 根据手机验证码获取账号列表
  CheckChangePassCaptcha: '/api/services/app/Account/CheckChangePassCaptcha', // 找回密码: 验证账号、绑定的手机号码
  ChangePassword: '/api/services/app/Account/ChangePassword', // 找回密码：修改密码
  GetByProviderKey: 'api/services/app/AbpTenantService/GetByProviderKey', // 获取绑定的平台
  GetNoTenantPaged: '/api/services/app/UserAudit/GetNoTenantPaged', // 获取入库审核记录(分页)
  ADotnetLogin: '/login', // Anet登陆
  CreateOrUpdate: '/api/services/app/tokenRecord/CreateOrUpdate' // 保存token
}

let userType
if (location.pathname === '/mLogin') {
  userType = 'medical'
} else {
  userType = 'userCenter'
}
export const aAxios = userType === 'medical' ? medicalUserService : UserCenterService
export const bAxios = userType === 'medical' ? medicalUserService : bUserService
export const middlewareAxios = middlewareService

// 获取已入库平台
export function GetByProviderKey (params) {
  return bAxios({
    url: api.GetByProviderKey,
    method: 'get',
    params
  })
}
// 企业微信登录
export function wxWorkAuthorizationLogin (parameter) {
  return aAxios({
    url: '/api/TokenAuth/wechatExternalAuthenticateYoushan',
    method: 'post',
    data: parameter
  })
}

// 获取入库审核记录(分页)
export function GetNoTenantPaged(params) {
  return bAxios({
    url: api.GetNoTenantPaged,
    method: 'get',
    params
  })
}

// A平台登录成功
export async function ALoginSuccess (result, tenantId, isJump = true) { // isJump: 是否跳转
  if (!isJump) {
    return
  }
  let tokenId
  // 判断是否b平台激活
  try {
    // if (result?.userId && tenantId !== 2) { // 非供应商
    //   const res = await GetByProviderKey({
    //     providerKey: result.userId
    //   })
    //   if (res.result.totalCount === 0) {
    //     // 获取审核状态
    //     const resultUserAudit = await GetNoTenantPaged({
    //       filter: `providerKey == "${result.userId}"`,
    //       pageNum: 1,
    //       pageSize: 99
    //     })
    //     if (resultUserAudit.success && resultUserAudit.result?.items?.[0]?.status === '1') {
    //       notification.error({
    //         message: '错误',
    //         description: '账户审核失败',
    //         duration: 4
    //       })
    //       return false
    //     }
    //     // 跳转到审核记录页
    //     // if (tenantId === 2) {
    //     //   window.location.replace(`${window.urlConfig.webs.mainUrl}?token=${result.accessToken}&tId=${tenantId}&redirectUrl=${location.origin}/userCenter`)
    //     // }
    //     notification.error({
    //       message: '错误',
    //       description: '账户暂未激活审核，请耐心等待',
    //       duration: 4
    //     })
    //     return
    //   }
    // }
    // if (window.urlConfig?.otherSetting?.isNeedDotNetToken === 'true') {
    //   const tokenData = await CreateOrUpdateToken({
    //     aToken: Vue.ls.get(A_DOTNET_ACCESS_TOKEN),
    //     aJAVAToken: result.accessToken
    //   }, tenantId, result.accessToken)
    //   tokenId = tokenData.result.id
    // }
    // Vue.ls.set(A_ACCESS_TOKEN, result.accessToken)
    // Vue.ls.set(A_TENANT_ID, tenantId)
  } catch (err) {
    const errMsgHandle = (errorMsg) => {
      if (errorMsg === '找到多个用户，请联系管理员处理') {
        return errorMsg
      }
    }
    notification.error({
      message: '错误',
      description: errMsgHandle(err?.message),
      duration: 4
    })
    return
  }
  switch (tenantId) {
    case 4: // 专家
      break
  }
  // if (location.pathname === '/mLogin') {
  //   window.location.replace(`${window.urlConfig.webs.mainUrl}?token=${result.accessToken}&tId=${tenantId}&redirectUrl=${location.origin}${location.pathname}`)
  // }
  // if (location.pathname === '/sysu/login') {
  //   window.location.replace(`${window.urlConfig.webs.mainUrl}?token=${result.accessToken}&tId=${tenantId}&redirectUrl=${location.origin}${location.pathname}`)
  // }
  if (location.pathname === '/login') {
    const routeParams = getUrlParams()
    // 如果路径上有带token的话需要清除token
    if (routeParams.token) {
      delete routeParams.token
      delete routeParams.tId
    }
    const search = '&' + Object.entries(routeParams).map(i => `${i[0]}=${encodeURIComponent(i[1])}`).join('&')
    window.location.replace(`${window.urlConfig.webs.mainUrl}?token=${result.accessToken}&tId=${tenantId}&tokenId=${tokenId}&redirectUrl=${location.origin}${location.pathname}${search}`)
  }
  // if (location.pathname === '/bgw/login' || location.pathname === '/fwbz/login') {
  //   window.location.replace(`${window.urlConfig.webs.mainUrl}?token=${result.accessToken}&tId=${tenantId}&redirectUrl=${location.origin}${location.pathname}`)
  // }
  // if (location.pathname === '/zcpt/login') {
  //   window.location.replace(`${window.urlConfig.webs.mainUrl}?token=${result.accessToken}&tId=${tenantId}&redirectUrl=${location.origin}${location.pathname}`)
  // }
  setTimeout(() => {
    notification.success({
      message: '欢迎',
      description: `${timeFix()}，欢迎回来`
    })
  }, 1000)
}

// A平台登录
export function ALoginJumpPage (params, tenantId) {
  return new Promise((resolve, reject) => {
    try {
      aAxios({
        url: api.ALogin,
        method: 'POST',
        data: params,
        headers: {
          'Abp.TenantId': tenantId
        }
      }).then(({ success, result, error }) => {
        if (success) {
          ALoginSuccess(result, tenantId)
          resolve('登录成功')
        } else {
          reject(error)
        }
      })
    } catch (err) {
      reject(err)
    }
  })
}

// Anet登录
export function ADotnetLogin ({ username, password }, tenantId) {
  return aAxios({
    url: api.ADotnetLogin,
    method: 'POST',
    params: {
      username,
      password
    },
    headers: {
      TenantId: tenantId
    }
  })
}

// B平台登录
export function BLoginJumpPage (params) {
  return new Promise((resolve, reject) => {
    try {
      bAxios({
        url: api.BLogin,
        method: 'POST',
        data: params,
        headers: {
          'Abp.TenantId': 1
        }
      }).then(({ success, result, error }) => {
        if (success) {
          if (location.pathname === '/mLogin') {
            window.location.href = `${window.urlConfig.webs.medicalHomeUrl}?bToken=${result.accessToken}`
          }
          if (location.pathname === '/sysu/login') {
            window.location.href = `${window.urlConfig.webs.medicalHomeUrl}?bToken=${result.accessToken}`
          }
          if (location.pathname === '/login') {
            window.location.href = `${window.urlConfig.webs.medicalHomeUrl}?bToken=${result.accessToken}`
          }
          if (location.pathname === '/userCenter') {
            window.location.href = `${window.urlConfig.webs.medicalHomeUrl}?bToken=${result.accessToken}`
          }
          resolve('登录成功')
          setTimeout(() => {
            notification.success({
              message: '欢迎',
              description: `${timeFix()}，欢迎回来`
            })
          }, 1000)
        } else {
          reject(error)
        }
      })
    } catch (err) {
      reject(err)
    }
  })
}

// A平台登录
export function getATenantList (params) {
  return aAxios({
    url: api.getATenantList,
    method: 'GET',
    params
  })
}

// 获取手机验证码
export function SendAliSmsAsync (params) {
  return aAxios({
    url: api.SendAliSmsAsync,
    method: 'POST',
    data: params
  })
}

// 根据手机验证码获取账号列表
export function GetCaptchaAccountByPhone (params) {
  return aAxios({
    url: api.GetCaptchaAccountByPhone,
    method: 'GET',
    params
  })
}

// 找回密码: 验证账号、绑定的手机号码
export function CheckChangePassCaptcha (params) {
  return aAxios({
    url: api.CheckChangePassCaptcha,
    method: 'POST',
    data: params
  })
}

// 找回密码：修改密码
export function ChangePassword (params) {
  return aAxios({
    url: api.ChangePassword,
    method: 'POST',
    data: params
  })
}

function CreateOrUpdateToken (params, tenantId, aToken) {
  return aAxios({
    url: api.CreateOrUpdate,
    method: 'post',
    data: params,
    headers: {
      'Abp.TenantId': tenantId,
      Authorization: `Bearer ${aToken}`
    }
  })
}
